export default __webpack_public_path__ + "static/media/hht2_ep15_timeline_06.0c13dd8c.png";